module.exports = __webpack_public_path__ + "media/src/img/payment/image2-2cc3e7b5431c474234aa28c346df7d94.png";